import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import { allImages } from "../../assets";

const AuthContainer = ({ children }) => {
  return (
    <Box
      sx={{
        background: appcolors.authGradient,
        position: "relative",
        minHeight: { md: "100vh" },
        // maxWidth: "1400px",
        margin: "auto",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            padding: 2,
            position: "relative",
            zIndex: 999,
          }}
        >
          <Typography
            variant="h1"
            fontSize={"1.875rem"}
            fontWeight={600}
            color={appcolors.white}
          >
            LOBA
          </Typography>

          <Typography
            mt={3}
            variant="h1"
            fontWeight={600}
            color={appcolors.softGrey}
            sx={{
              fontSize: { xs: "1.785rem", sm: "2.188rem" },
            }}
          >
            CRM For your Salon & Sap
          </Typography>
          <Typography variant="body2" color={appcolors.white}>
            Our ambition is to make it the most efficient, innovative and
            revolutionary management CRM.
          </Typography>
          <img
            src={allImages.authOverlay}
            alt="auth-image"
            width={"35%"}
            className="auth-overlay-image-bf600"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            backgroundColor: appcolors.white,
            padding: { xs: "24px 8px", md: 3 },
            borderRadius: { md: "30px 0px 0px 30px" },
            minHeight: { md: "100vh" },
            // display:"flex",
            // flexDirection:"column",
            // justifyContent:"center",
            // alignItems:"center",
          }}
        >
          {children}
        </Grid>
      </Grid>

      {/* floating image */}
      <img
        src={allImages.authOverlay}
        alt="auth-image"
        width={"35%"}
        className="auth-overlay-image"
      />
    </Box>
  );
};

export default AuthContainer;
